import {buildFilterQuery, Filter} from '@app/utils/_msf';
import {FilterOperator} from '@app/utils/filter-operator';
import {
  defaultCropIdentificationResultFilters,
  toAiInferenceImageDataSource,
} from '../gis-crop-identification/crop-identification-result-filter.util';

/**
 * Filters for list Apply (GetExtendedList + GetTotalCount) and Export.
 * The form key `source` is not a CropIdentificationResult column.
 */
export function buildCropIdentificationListFilters(
  model: Record<string, unknown> | null | undefined,
): Filter[] {
  const queryModel: Record<string, unknown> = {};
  if (model) {
    for (const [key, value] of Object.entries(model)) {
      if (key === 'source') {
        continue;
      }
      queryModel[key] = key === 'identificationDate' ? formatListIdentificationDate(value) : value;
    }
  }

  const filters = [
    ...defaultCropIdentificationResultFilters(),
    ...buildFilterQuery(queryModel as Record<string, Object>),
  ];
  const source = toAiInferenceImageDataSource(model?.['source']);
  if (source != null) {
    filters.push({
      filterField: 'aiInferenceImageDataSource',
      filterOperator: FilterOperator.Equals,
      filterValue: source,
    });
  }
  return filters;
}

function formatListIdentificationDate(raw: unknown): unknown {
  if (raw == null || raw === '') {
    return raw;
  }
  if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw.trim())) {
    return raw.trim();
  }
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
    const year = raw.getFullYear();
    const month = String(raw.getMonth() + 1).padStart(2, '0');
    const day = String(raw.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  return raw;
}
